import React from "react";
import { formatDate } from "../../helper/Helper";
import { Link } from "react-router-dom";
import { showError, showSuccess } from "../../utils/toastUtils";

const FormRow = React.memo(({ form, index, page, limit, onDelete }) => {
  const copyText = async (id) => {
    try {
      await navigator.clipboard.writeText(id);
      showSuccess("Copied");
    } catch {
      showError("Copy failed");
    }
  };

  return (
    <tr>
      <td>{(page - 1) * limit + index + 1}.</td>

      <td>
        <div className="d-flex align-items-center file-name-icon">
          <div>
            <h6 className="fw-medium">{form.name}</h6>
            <div className="d-flex">
              <span className="fs--1 me-1">{form._id}</span>
              <span
                className="fs--1 fa fa-copy cursor-pointer"
                onClick={(e) => copyText(form._id)}
              ></span>
            </div>
          </div>
        </div>
      </td>

      <td>{form.fieldCount}</td>
      <td>{form.submissionCount}</td>
      <td>{form.strict === true ? "true" : "false"}</td>
      <td>{formatDate(form.createdAt)}</td>
      <td className="action-table-data">
        <div className="edit-delete-action">
          <Link
            to={`/submissions/${form._id}`}
            className="me-2 p-2"
            state={{ id: form._id }}
          >
            <i className="ti ti-eye me-1" /> View Submission
          </Link>
          <Link
            to={`/form/edit/${form._id}`}
            className="me-2 p-2"
            state={{ id: form._id }}
          >
            <i className="ti ti-pencil" />
          </Link>

          <a
            className="p-2"
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            onClick={(e) => {
              onDelete(form._id);
            }}
          >
            <i className="ti ti-trash" />
          </a>
        </div>
      </td>
    </tr>
  );
});

export default FormRow;
